import { Link } from 'react-router-dom';
import { MapPin, Search, Star } from 'lucide-react';
import { Reveal } from './Reveal.tsx';
import type { SiteConfig } from '../../siteContentTypes.ts';

export function Matching({ config }: { config: SiteConfig }) {
  const { matching } = config;

  return (
    <section style={{ padding: '56px 24px', maxWidth: 900, margin: '0 auto' }}>
      <Reveal>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          <h2 style={{ fontSize: 28, fontWeight: 800, margin: '0 0 10px' }}>{matching.title}</h2>
          <p style={{ color: 'var(--text-secondary)', fontSize: 15 }}>{matching.description}</p>
        </div>

        <div className="card" style={{ padding: 24, display: 'flex', flexDirection: 'column', gap: 16 }}>
          <div className="searchbar" style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Search size={18} color="var(--text-tertiary)" />
            <span style={{ fontSize: 14, fontWeight: 600 }}>{matching.searchExample}</span>
          </div>

          <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
            {matching.profiles.map((profile, i) => (
              <Reveal key={profile.name} delay={i * 0.12}>
                <div className="card" style={{ display: 'flex', alignItems: 'center', gap: 12, padding: 14 }}>
                  <div
                    style={{
                      width: 44,
                      height: 44,
                      borderRadius: '50%',
                      background: 'var(--accent-tint)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      fontWeight: 800,
                      color: 'var(--accent-dark)',
                      flexShrink: 0,
                      overflow: 'hidden',
                    }}
                  >
                    {profile.photo ? <img src={profile.photo} alt="" style={{ width: '100%', height: '100%', objectFit: 'cover' }} /> : profile.name[0]}
                  </div>
                  <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ fontWeight: 800, fontSize: 14 }}>{profile.name}</div>
                    <div style={{ fontSize: 12, color: 'var(--text-secondary)' }}>
                      {profile.experience} · {profile.skills}
                    </div>
                  </div>
                  <div style={{ textAlign: 'right', flexShrink: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, justifyContent: 'flex-end' }}>
                      <Star size={12} color="var(--accent)" fill="var(--accent)" />
                      <span style={{ fontSize: 12.5, fontWeight: 700 }}>{profile.rating}</span>
                    </div>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: 11.5, color: 'var(--text-tertiary)' }}>
                      <MapPin size={11} /> {profile.distance}
                    </div>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>

          <Link to={matching.ctaUrl} className="btn btn-primary" style={{ marginTop: 8 }}>
            {matching.ctaText}
          </Link>
        </div>
      </Reveal>
    </section>
  );
}
